import { render, staticRenderFns } from "./AdviserEnrolment.vue?vue&type=template&id=e1872d56&scoped=true"
import script from "./AdviserEnrolment.vue?vue&type=script&lang=js"
export * from "./AdviserEnrolment.vue?vue&type=script&lang=js"
import style0 from "./AdviserEnrolment.vue?vue&type=style&index=0&id=e1872d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1872d56",
  null
  
)

export default component.exports